import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';

/** Password input hidden by default with an eye toggle; never logs value. */
export function PasswordField({
  label,
  value,
  onChange,
  autoComplete = 'new-password',
  placeholder,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  placeholder?: string;
}) {
  const [visible, setVisible] = useState(false);
  return (
    <label className="field-group field-group--password">
      <span>{label}</span>
      <span className="field-group__input">
        <input
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          autoComplete={autoComplete}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          placeholder={placeholder}
        />
        <button
          type="button"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? `Скрыть ${label.toLowerCase()}` : `Показать ${label.toLowerCase()}`}
        >
          {visible ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </span>
    </label>
  );
}

export type ConnectionState = 'idle' | 'checking' | 'success' | 'error';

/** Inline connection test status panel with useful error messages. */
export function ConnectionTest({
  state,
  successTitle,
  successMessage,
  errorTitle,
  errorMessage,
}: {
  state: ConnectionState;
  successTitle: string;
  successMessage: string;
  errorTitle: string;
  errorMessage: string;
}) {
  return (
    <div className={`camera-form__connection camera-form__connection--${state}`} aria-live="polite">
      {state === 'success' && (
        <span>
          <strong>{successTitle}</strong>
          <small>{successMessage}</small>
        </span>
      )}
      {state === 'error' && (
        <span>
          <strong>{errorTitle}</strong>
          <small>{errorMessage || 'Проверьте адрес, порт и учётные данные.'}</small>
        </span>
      )}
    </div>
  );
}
